import React, { Component } from "react"
import { searchTableFilter, SumTable } from "../Tree/Utils.js"
import { expenseCategory } from '../../variables/ComboValues'
import SearchBar from '../Tree/components/SearchBar.jsx'
//import { EditableCell } from '../TableList/EditableCell'
import { ProductRow } from '../TableList/ProductRow'
// input (props) 
//      tableTitle={"תוכנית עבודה"}
//      familyCode - TBD
// Resources: see import above

// TODO: get data from DB && Update to DB

export const  Expenses_microLegend = { 
    expense_purpose: "מטרת ההוצאה", // not in use
    expense_category: "קטגוריה",
    expense_sum: "סכום"
}

export class FamilyExpenses extends Component {

    constructor(props) {
      super(props)
      this.state = { products: this.props.data }
      this.onSaveTable = this.onSaveTable.bind(this)
      this.handleProductTable = this.handleProductTable.bind(this)
    }
    
    handleRowDel(product) {
      const {products} = this.state
      var index = products.indexOf(product)
      if (index === -1)
        return console.log("FamilyRights productnot found", product)

      var array = [...products]
      //this.state.products.splice(index, 1)
      array.splice(index, 1)
      this.setState({products:array})
    }
    /*
    handleRowDel(product) {
      var index = this.state.products.indexOf(product)
      this.state.products.splice(index, 1)
      this.setState(this.state.products)
    }*/
  
    handleAddEvent(evt) {
      evt.preventDefault()
      var id = (+ new Date() + Math.floor(Math.random() * 999999)).toString(36);
      var product = {
        id: id,
        expense_purpose: "" ,
        expense_category: "",
        expense_sum: ""
      }
      let newp = ""
      if (this.state.products === undefined || this.state.products === false ){
        newp = [product]
      } else {
        newp = Object.assign(this.state.products)
        newp.unshift(product)
      }
      this.setState({products:newp})
    }
  
    handleProductTable(evt) {
      evt.preventDefault()

        var item = {
            //id: evt.target.id,
            name: evt.target.name,
            value: evt.target.value,
            nid: evt.target.getAttribute('data-id')
        }
        // console.log("pRODUCT-EVT", item);

        var products = this.state.products.slice();
        // console.log("products-EVT", products);

        var newProducts = products.map(function(product) {
  
            for (var key in product) {
                if (key === item.name && product.id === item.nid) {
                    product[key] = item.value
                }
            }
            return product
        })
        this.setState({products:newProducts})

    }

    // update data base
    onSaveTable(evt) {
      evt.preventDefault()
      const { save2DB, subTableId, familyPostId, inUpdate, mbouser } = this.props
      console.log("Family General save table: products", this.state.products)
   
      save2DB(familyPostId, this.state.products, subTableId, "table", inUpdate, mbouser )
    }
    render() {
      const {tableTitle} = this.props
      // const { data } = this.props
      // console.log("Family general data", data)
      //console.log("OLD meeting data", this.state.products)
      
      return (
          <ProductTable 
          onProductTableUpdate={this.handleProductTable}
          onSaveTable={this.onSaveTable} 
            headerColumns = {["expense_category", "expense_purpose","expense_sum"]}
            tableTitle = {tableTitle} // "סיכומי מפגשים"
            onRowAdd={this.handleAddEvent.bind(this)} 
            onRowDel={this.handleRowDel.bind(this)} 
            products={this.state.products} 
          />
      )
    }
  }
  /*   class SearchBar extends Component { moved to file */
   
  class ProductTable extends Component {
    constructor(props){
        super(props)
        this.state={
            filterText : ""
        }
    }
    
    handleUserInput(filterText) {
        this.setState({filterText: filterText});
    }
    render() {
      const { onProductTableUpdate, onRowDel, onRowAdd, headerColumns, products, tableTitle, onSaveTable } = this.props
      var filterText = this.state.filterText;
      var thStyle = { fontSize: '15px',color:'#333', fontWeight: 'bold'}
      var buttonStyle = {marginRight: '0'}
      var searchbarStyle = {margin: '5px 10px'}
      var product = typeof products === "undefined" || products === false ? null : products.map(function(product) {
          // check on all relevant data fields
          if (!searchTableFilter(product, filterText))
                return null;
            
        const cellData=[{
            type: "select",
            options: expenseCategory, // ["דיור", "תקשורת", "מזון", "בריאות", "חינוך", "החזר חובות", "פנאי", "מתנות", "אחר"],
            name: "expense_category",
            value: product.expense_category,
            id: product.id,
            style: {width: "130px"},
            edit: true
          },{
            type: "text",
            name: "expense_purpose",
            value: product.expense_purpose,
            id: product.id,
            style: {width: "230px"},
            edit: true
          },{
            type: "text",
            name: "expense_sum",
            value: product.expense_sum,
            id: product.id,
            style: {width: "100px"},
            edit: true
          }] 
          
        return (
          <ProductRow 
            onProductTableUpdate={onProductTableUpdate} 
            product={product} 
            onDelEvent={onRowDel.bind(this)} 
            key={product.id}
            cd={cellData}
            />)
      })

      return (
        <div className="yahav-modal">
            <h2 >{tableTitle}&nbsp;חודשיות&nbsp;(סה"כ&nbsp;{products === undefined ? 0 : products.length})</h2>
            <button style={buttonStyle} type="button" onClick={onRowAdd} className="btn btn-success pull-right">הוספת שורה</button>
            <button style={buttonStyle} type="button"  className="btn btn-success pull-left" onClick={onSaveTable}>עדכון</button>
            <SearchBar style={searchbarStyle} filterText={this.state.filterText} onUserInput={this.handleUserInput.bind(this)} />
            <SumTable products={products} field={'expense_sum'} title={'סה"כ הוצאות'} />
            <table className="table ">
                <thead>
                    <tr >
                    {headerColumns.map (col => { 
                      return(<th style={thStyle} key={col}>{Expenses_microLegend[col]?Expenses_microLegend[col] : col}</th>) 
                  }) } 
                    </tr>
                </thead>  
                <tbody>
                    {products === undefined ? null : product}
                </tbody>
            </table>
            <ul><li>החזרי חובות ותשלומי משכנתא יש להוסיף בטבלאות המתאימות בלשונית התחייבויות</li></ul>
        </div>
      )
    }
  }
 